//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Toast } from 'mint-ui'
import { Const } from '@/consts'
import infoApi from '@/api/info'

export default {
  data () {
    return {
      allLoaded: false,
      typeMap: {
        news: 'NEWS',
        training: 'TRAINING'
      },

      data: {
        items: []
      },

      pageNo: 0,
      pageSize: 5,
    }
  },


  mounted () {
    // this.getHighlighList();
    // this.list('NEWS');
    // this.list('PUBLICITY');
    // this.list('EXTRAREADING');
    // this.listCourse();
    if (this.$route.query.type) {
      this.refresh()
    } else {
      this.refresh2()
    }
  },

  methods: {

    refresh () {
      this.data.items = [];
      this.allLoaded = false;
      this.pageNo = 0;
      this.pageSize = 30;
      this.loadMore(true);
      this.$refs.loadMore.onTopLoaded();
      this.pageSize = 5;

    },

    refresh2 () {
      this.data.items = [];
      this.allLoaded = false;
      this.pageNo = 0;
      this.pageSize = 30;
      this.loadMore2(true);
      this.$refs.loadMore2.onTopLoaded();
      this.pageSize = 5;

    },

    loadMore (onlyOnce) {

      infoApi.getInfoList({
        params: {
          infotype: this.typeMap[this.$route.query.type],
          pageno: this.pageNo++,
          pagesize: this.pageSize
        }
      }).then((resp) => {
        const result = resp[Const.RESP_RESULT] || [];

        if (!result || !result[0]) {
          this.allLoaded = true;
        } else {
          this.data.items.push(...result)
        }
        if (!onlyOnce) {
          this.$refs.loadMore.onBottomLoaded();
        }

      }).catch((resp) => {
        if (resp.statusCode == '200') {
          Toast(resp[Const.RESP_MESSAGE] || '获取信息失败');
        }
      });
    },

    loadMore2 () {
      infoApi.getCourseInfoList({
        params: {
          pageno: this.pageNo++,
          pagesize: this.pageSize
        }
      }).then((resp) => {
        const result = resp[Const.RESP_RESULT] || [];

        if (!result || !result[0]) {
          this.allLoaded = true;
        } else {
          this.data.items.push(...result)
        }

        if (!onlyOnce) {
          this.$refs.loadMore2.onBottomLoaded();
        }
      }).catch((resp) => {
        // Toast(resp[Const.RESP_MESSAGE] || '获取失败');
        if (resp.statusCode == '200') {
          Toast(resp[Const.RESP_MESSAGE] || '获取信息失败');
        }
      });
    },

    showInfoDetail (item) {
      let type = this.$route.query.type;
      this.$router.push({ path: '/information/detail', query: { id: item.infoid || '', from: 'information-more?type=' + (type || '') } });
    },

    goBack () {
      this.$router.replace({ path: '/information' });
    },

    handleBottomChange (status) {
      // console.log(status)
    }
  }
}



// WEBPACK FOOTER //
// ./src/view/information/more.vue